import React from "react";
import { AppText } from "./index";

type AppTitleProps = React.ComponentProps<typeof AppText> & {
  level?: 1 | 2 | 3 | 4 | 5; // optional for semantic levels
};

export const AppTitle: React.FC<AppTitleProps> = ({
  level = 1,
  size,
  weight = "semiBold",
  ...props
}) => {
  // map heading levels to font size
  const sizes: Record<number, number> = {
    1: 32,
    2: 24,
    3: 20,
    4: 18,
    5: 16,
  };

  return (
    <AppText
        as={`h${level}` as any}
        size={size ?? sizes[level]}
        weight={weight}
        {...props}
        style={{
          ...props.style,
          margin: 0,
        }}
    />
  );
};
